flexFont = function () {
    var flexTitle = document.getElementsByClassName("flex-title");
    for(var i = 0; i < flexTitle.length; i++) {
        var relFontsize = flexTitle[i].offsetWidth*0.2;
        if (window.innerWidth > 768){
            flexTitle[i].style.fontSize = relFontsize+'px';
        } else{
            flexTitle[i].style.fontSize  = null;
        }
    }
};

if (document.getElementsByClassName("flex-title").length > 0){
    flexFont();
    
    window.onresize = function(event) {
        flexFont();
    };
} 
